import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import React from 'react';
import Icon from '../Icon';
import Paragraph from '../Paragraph';
/**
 *
 * This component is used for displaying form inline error
 * @param {Props} { children, ...others }
 * @returns {Node}
 */

var FieldError = function FieldError(_ref) {
  var children = _ref.children,
      others = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement("div", _extends({
    "aria-live": "assertive",
    role: "alert"
  }, others, {
    className: "field-error form-error is-visible"
  }), React.createElement(Icon, {
    iconType: "error"
  }), React.createElement(Paragraph, null, children));
};

FieldError.defaultProps = {
  className: ''
};
FieldError.displayName = 'FieldError';
export default FieldError;